export type ChatProcessNotification = {
  id: string;
  conversationId: string;
  runId: string;
  kind: string;
  label: string;
  status: "completed" | "failed";
  message: string | null;
  completedAt: string;
};

export type ConversationProcessBadge = {
  conversationId: string;
  status: "completed" | "failed";
  count: number;
};

export function badgesFromNotifications(
  notifications: ChatProcessNotification[]
): Map<string, ConversationProcessBadge> {
  const byConversation = new Map<string, ConversationProcessBadge>();
  for (const notification of notifications) {
    const existing = byConversation.get(notification.conversationId);
    if (!existing) {
      byConversation.set(notification.conversationId, {
        conversationId: notification.conversationId,
        status: notification.status,
        count: 1,
      });
      continue;
    }
    existing.count += 1;
    // Prefer failed if any unseen run failed.
    if (notification.status === "failed") existing.status = "failed";
  }
  return byConversation;
}
